import React, { useEffect, useMemo, useState } from "react";
import api, { apiError } from "../lib/api";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Button } from "./ui/button";
import { Check, ChevronsUpDown } from "lucide-react";

// Searchable cost-code dropdown that prevents invalid manual entry.
export default function CostCodeSelect({ codes, value, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const selected = codes.find((c) => c.cost_code === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" data-testid={testid}
                className="w-full justify-between font-mono h-9">
          {selected ? `${selected.cost_code} — ${selected.description}` : "Select cost code…"}
          <ChevronsUpDown className="ml-2 h-4 w-4 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[320px] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search cost code…" />
          <CommandList>
            <CommandEmpty>No cost code found.</CommandEmpty>
            <CommandGroup>
              {codes.map((c) => (
                <CommandItem key={c.cost_code} value={`${c.cost_code} ${c.description}`}
                  onSelect={() => { onChange(c.cost_code); setOpen(false); }}
                  data-testid={`cc-option-${c.cost_code}`}>
                  <Check className={`mr-2 h-4 w-4 ${value === c.cost_code ? "opacity-100" : "opacity-0"}`} />
                  <span className="font-mono mr-2">{c.cost_code}</span>
                  <span className="text-slate-500 text-sm truncate">{c.description}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
